/**
 * DebugPanelRepository — mirrors ConneXt v2 DebugPanelRepository.
 * Handles storage for debug panel state (custom config, log level, zip, etc.)
 */
import { localStorageService } from '@Engage.Data/services/storage/localStorage/LocalStorageService';
import { StorageKeys } from '@Engage.Data.Constants';
export class DebugPanelRepository {
    static setSiteCode(siteCode) {
        localStorageService.set(this.keys.SiteCode, siteCode, { expandKey: false, isSecureValue: false });
    }
    static getSiteCode() {
        return localStorageService.get(this.keys.SiteCode, { expandKey: false, isSecureValue: false });
    }
    static setConfigCode(configCode) {
        localStorageService.set(this.keys.ConfigCode, configCode, { expandKey: false, isSecureValue: false });
    }
    static getConfigCode() {
        return localStorageService.get(this.keys.ConfigCode, { expandKey: false, isSecureValue: false });
    }
    static setIsCustomConfiguration(isCustom) {
        localStorageService.set(this.keys.ConfigurationIsCustom, isCustom, { expandKey: false });
    }
    static getIsCustomConfiguration() {
        return !!localStorageService.get(this.keys.ConfigurationIsCustom, { expandKey: false });
    }
    static getZipCodes() {
        return localStorageService.get(this.keys.ZipCode, { expandKey: false });
    }
    static setZipCodes(zipCode) {
        localStorageService.set(this.keys.ZipCode, zipCode, { expandKey: false });
    }
    static removeZipCodes() {
        localStorageService.delete(this.keys.ZipCode, { expandKey: false });
    }
    static getLogLevel() {
        return localStorageService.get(this.keys.LogLevel, { expandKey: false });
    }
    static setLogLevel(logLevel) {
        localStorageService.set(this.keys.LogLevel, logLevel, { expandKey: false });
    }
    static getDebugMode() {
        return !!localStorageService.get(StorageKeys.DebugMode, { expandKey: false });
    }
    static setDebugMode(value) {
        localStorageService.set(StorageKeys.DebugMode, value, { expandKey: false });
    }
    static getEngagementRate() {
        return localStorageService.get(StorageKeys.EngagementRate, { expandKey: false });
    }
    static setEngagementRate(rate) {
        localStorageService.set(StorageKeys.EngagementRate, rate, { expandKey: false });
    }
    static getDebugPanelOpenState() {
        return !!localStorageService.get(this.keys.DebugPanelOpenState, { expandKey: false });
    }
    static setDebugPanelOpenState(isOpen) {
        localStorageService.set(this.keys.DebugPanelOpenState, isOpen, { expandKey: false });
    }
    static clearConfiguration() {
        this.removeZipCodes();
        localStorageService.delete(this.keys.SiteCode, { expandKey: false });
        localStorageService.delete(this.keys.ConfigCode, { expandKey: false });
        localStorageService.delete(this.keys.ConfigurationIsCustom, { expandKey: false });
    }
}
DebugPanelRepository.keys = StorageKeys.DebugPanel;
